export enum EPropertyApplicationsCustom {
  All = "ALL",
  CandidateVisitors = "CANDIDATE_VISITORS",
  Invited = "INVITED",
  WaitingList = "WAITING_LIST",
  ScheduleForVisit = "SCHEDULE_FOR_VISIT",
  Visitors = "VISITORS",
  CandidateTenants = "CANDIDATE_TENANTS",
  Tenant = "TENANT",
  NotEligible = "NOT_ELIGIBLE",
  WithApplications = "WITH_APPLICATIONS",
  Archived = "ARCHIVED",
}
